import React, { useState } from "react";
import tools from "../../../../../helpers/tools";
import Control from "../../../../common/Controls/Control";
import BlockWrapper from "../../Layout/BlockWrapper";
import useFormState from "../useFormState";
import ActivitiesOfSector from "./ActivitiesOfSector";
import SelectedActivities from "./SelectedActivities";
import SuggestedActivities from "./SuggestedActivities";
import categories from "../../../Forms/categories.json";
import activites from "../../../Forms/activities.json";

const RCPROActiviteInputs = ({ company }) => {
  const [selectedSecteur, setSelectedSecteur] = useState(null);
  const [searchModel, setSearchModel] = useState("ACTIVITE");
  let { actions, errors, inputsConfig, formData } = useFormState();
  console.log("formData", formData);

  const onAddActivite = (a) => {
    if (a.target.value == "") return;
    updateActiviteState([
      ...formData.activiteInputs.activitesPro,
      a.target.value,
    ]);
  };

  const onRemoveActivite = (a) => {
    updateActiviteState(
      formData.activiteInputs.activitesPro.filter((a2) => a2 != a)
    );
  };

  const updateActiviteState = (newActivites) => {
    //si secteur deja pris, le retirer
    const newSecteurs = [];
    newActivites.forEach((activite) => {
      const secteurOfActivite = activites.find(
        (a2) => a2.id == activite
      ).rootCategoryId;
      if (!newSecteurs.includes(secteurOfActivite)) {
        newSecteurs.push(secteurOfActivite);
      }
    });
    actions.updateActiviteInputs({
      activitesPro: newActivites,
      secteursPro: newSecteurs,
    });
  };

  const onSelectSecteur = (e) => {
    setSelectedSecteur(e.target.value);
  };
  const onSelectActivity = (a) => {
    //si activité déjà présente, la retirer
    let newActivites = [];
    if (formData.activiteInputs.activitesPro.includes(a)) {
      newActivites = formData.activiteInputs.activitesPro.filter(
        (a2) => a2 != a
      );
    } else {
      newActivites = [...formData.activiteInputs.activitesPro, a];
    }
    updateActiviteState(newActivites);
  };

  return (
    <>
      <BlockWrapper>
        {searchModel == "ACTIVITE" && (
          <>
            <div>
              <Control
                label={inputsConfig.activitesPro?.label}
                type="autocomplete"
                name="activitesPro"
                value={[]}
                change={onAddActivite}
                error={errors}
                labelClassname="w-100"
                inputGroupStyle={{ width: "100%" }}
                btnInline
                placeholder={
                  formData.activiteInputs.activitesPro.length == 0
                    ? `Ex : Informatique`
                    : `${
                        formData.activiteInputs.activitesPro.length
                      } ${tools.getPlural(
                        "activité",
                        formData.activiteInputs.activitesPro.length
                      )} ${tools.getPlural(
                        "sélectionnée",
                        formData.activiteInputs.activitesPro.length
                      )}`
                }
                datas={activites.filter(
                  (a) =>
                    !formData.activiteInputs.activitesPro.includes(a.id + "")
                )}
                dataIndex="id"
                dataLabel="name"
                dataLabel2="alias"
                autoCompleteDisplayIndex="name"
                info={
                  <>
                    Saisissez les premières lettres de votre activité puis
                    sélectionnez dans la liste.
                  </>
                }
                required
              />
              <SelectedActivities
                activites={formData.activiteInputs.activitesPro || []}
                onRemoveActivite={onRemoveActivite}
              />
              <SuggestedActivities
                alreadySelectedActivities={formData.activiteInputs.activitesPro}
                companyActivityStr={``}
                onAddActivite={onAddActivite}
              />
            </div>

            {formData.activiteInputs.activitesPro.length == 0 && (
              <button
                className="btn btn-default bg-default shadow-small border-0 mt-3"
                onClick={() => setSearchModel("SECTEUR")}
              >
                Je ne trouve pas mon activité
              </button>
            )}
          </>
        )}
        {searchModel == "SECTEUR" && (
          <div>
            <Control
              label="Sélectionnez votre secteur d'activité"
              type="autocomplete"
              name="activitesPro"
              value={selectedSecteur}
              change={onSelectSecteur}
              error={errors}
              labelClassname="w-100"
              inputGroupStyle={{ width: "100%" }}
              btnInline
              datas={categories.filter(
                (a) => !formData.activiteInputs.activitesPro.includes(a.id + "")
              )}
              dataIndex="id"
              dataLabel="name"
              autoCompleteDisplayIndex="name"
              info={
                <>
                  Sélectionnez votre secteur puis choisissez vos activités dans
                  la liste.
                  <ActivitiesOfSector
                    secteur={selectedSecteur}
                    onSelectActivity={onSelectActivity}
                    selectedActivities={
                      formData.activiteInputs.activitesPro || []
                    }
                  />
                </>
              }
              required
            />
            <SelectedActivities
              activites={formData.activiteInputs.activitesPro || []}
              onRemoveActivite={onRemoveActivite}
            />
            <SuggestedActivities
              alreadySelectedActivities={formData.activiteInputs.activitesPro}
              companyActivityStr={``}
              onAddActivite={onAddActivite}
            />
          </div>
        )}
      </BlockWrapper>
    </>
  );
};

export default RCPROActiviteInputs;
